import React, {Component} from 'react';
import {Icon, Popover,message} from 'antd'
import {NavLink, Redirect, withRouter} from 'react-router-dom'
import {connect} from 'react-redux'
import { bindActionCreators, compose} from 'redux'
import './index.scss'
import config from '@/config'
import { urlFormat, setStorage} from "@/utils";
import CScroll from '@/components/CScroll'
import store from "../../redux";
import { getStorage} from "@/utils";
class LeftNav extends Component {
  constructor(props) {
    super(props);
    this.listenRouterChange = this.listenRouterChange.bind(this);
    this.setState({
      fresh:store.getState().refresh
    })
    const id = localStorage.getItem('chooseid')
    this.setState({
      chooseid:id
    })
  }

  state = {
    fresh:false,
    collapsed:true,
    leftNavData: [],
    currentOpenIds: [],//当前展开项的id列表
    currentActiveId: '',//当前选中项的id
    leftNavdefaultOpenAll: config.leftNavdefaultOpenAll,//是否默认展开所有侧导航
    CollapseModel: config.CollapseModel,
    year:'',
    allrule:[
        '/base','/innovationReview','/innovationItem1',
        '/innovationItem2','/innovationItem3','/innovationItem4',
        '/innovationItem5','/innovationItem6','/innovationItem7'
    ],
    chooseid:''
  };

  /*展开收起事件*/
   changeToggle(data) {
    if (!data || !data.id) return;
    let currentOpenIds = this.state.currentOpenIds;
    // 手风琴模式
    if (this.state.CollapseModel) {
      // 如果当前点击项在数组中存在表明是关闭操作
      if (this.state.currentOpenIds.includes(data.id)) {
        currentOpenIds = [];
      } else {
        currentOpenIds = [data.id];
      }
      // currentOpenIds = this.state.currentOpenIds.length ? [] : [data.id];
    } else {
      // 如果当前点击项在数组中存在表明是关闭操作
      if (this.state.currentOpenIds.includes(data.id)) {
        let index = this.state.currentOpenIds.indexOf(data.id);
        this.state.currentOpenIds.splice(index, 1);
        currentOpenIds = this.state.currentOpenIds;
      } else {
        currentOpenIds = [...this.state.currentOpenIds, data.id];
      }
    }
     this.setState({
      currentOpenIds: currentOpenIds,
    });
  }

  /*初始化展开项的id列表  针对于配置默认全部展开和默认打开某个路由时需要展开项*/
  initOpenAll() {
    if (this.state.leftNavdefaultOpenAll) {
      let currentOpenIds = [];
      this.state.leftNavData.forEach(item => {
        if (item.children && item.children.length) currentOpenIds.push(item.id);
      });
      this.setState({
        currentOpenIds: currentOpenIds,
      })
    }
  }

  /*初始化当前选中项  判断当前路由下的选中项  this.props获取不到路由信息使用window.location代替*/
  initCurrentActive() {
    const chooseid = localStorage.getItem('chooseid')
    if (chooseid !== ''){
      this.setState({
        chooseid:chooseid
      })
    }
    let routeInfo = urlFormat(window.location.href);
    let hash = routeInfo.hash;

    // 过滤出选中的一级导航或者展开的一级导航
    let openOrSelectData = this.state.leftNavData.filter(item => {
      return hash.includes(item.rule)
    });
    if(!openOrSelectData.length){
      return
    }
    // 当前选中项一定是打开的，所以先删除当前选中项在currentOpenIds中的值
    let index = this.state.currentOpenIds.indexOf(openOrSelectData[0].id);
    let currentOpenIds = this.state.currentOpenIds;
    if(index > -1){
      this.state.currentOpenIds.splice(index, 1);
      currentOpenIds = this.state.currentOpenIds;
    }
    this.setState({
      currentOpenIds: currentOpenIds
    });
    // 展开二级路由所在的一级菜单
    this.changeToggle(openOrSelectData[0]);
    // 找到选中的一个菜单或者二级菜单
    let is_children = openOrSelectData[0].children && openOrSelectData[0].children.length;
    let currentActiveId = '';
    if (is_children) {
      let selectedChildrenData = openOrSelectData[0].children.filter(item => {
        return hash.includes(item.rule)
      });
      if (selectedChildrenData.length>0) {
        currentActiveId = selectedChildrenData[0].id;
      }

    } else {
      currentActiveId = openOrSelectData[0].id;
    }
    this.setState({
      currentActiveId: currentActiveId
    });
  }


  // 设置breadcrumb面包屑导航数据
  getRouterAndSetBreadcrumb(data){
    if (data) {
      setStorage('showids',data.attr)
      localStorage.setItem('chooseid',data.id)
      this.setState({
        chooseid:data.id
      })
      const userList = JSON.parse(localStorage.getItem('userList'))
      if (userList.clerklevel === '8'){
        this.props.history.push({
          pathname: data.rule,
        });
      } else {
        if (this.state.allrule.includes(data.rule) && this.props.libraryname === ''){
          message.error('请先选择博博物馆')
          return false
        }
        this.props.history.push({
          pathname: data.rule,
        });
      }
    }
  }

  // 监听路由变换
  listenRouterChange(){
    this.props.history.listen(()=>{
      const id = localStorage.getItem('chooseid')
      this.setState({
        chooseid:id
      })
      this.initCurrentActive();
    })
  }

  popoverContentRender(item) {
    if(item.children && item.children.length){
      return (
        <div className='popover-container'>
          {
            item.children.map((children_item, children_index) => {
              return <div className='popover-container-item' key={children_item.id}>
                <NavLink exact onClick={()=>this.getRouterAndSetBreadcrumb(children_item)} className={`flex item-link}`} to={children_item.pagedata}>
                  {children_item.name}
                </NavLink>
              </div>
            })
          }
        </div>
      )
    }
  }

  childrenRender(item){
    return (
      <div className='ellipsis left-nav-item'>
        {
          item.children && item.children.length ?
            <div className={`flex item-link ${this.state.currentOpenIds.includes(item.id) ? 'open' : ''}`} onClick={() => this.changeToggle(item)}>

                          <span className='left'>
                            {item.iconType === 'fa' ? <i className={`prefix-icon fa ${item.icon}`}></i> : <Icon className='prefix-icon' type={item.icon}/>}
                          </span>
            </div> : <NavLink exact onClick={()=>this.getRouterAndSetBreadcrumb(item)} className={`flex item-link`} to={item.rule}>

                <span className='left'>
                            {item.iconType === 'fa' ? <i className={`prefix-icon fa ${item.icon}`}></i> : <Icon className='prefix-icon' type={item.icon}/>}
                          </span>
            </NavLink>
        }
      </div>
    )
  }

  computedChild(item){
    return (
        <div className='ellipsis left-nav-item'>
          {
            item.children && item.children.length ?
                <div className={`flex item-link ${this.state.currentOpenIds.includes(item.id) ? 'open' : ''}`} onClick={() => this.changeToggle(item)}>
                        <span className='left'>
                          {item.iconType === 'fa' ? <i className={`prefix-icon fa ${item.icon}`}></i> :
                              <Icon className='prefix-icon' type={item.icon}/>}
                        </span>
                  {
                      this.props.collapsed && <span className='flex right'>
                            <div>{item.name}</div>
                            {item.children && item.children.length>0 && <i className='suffix-icon fa fa-angle-down'></i>}
                          </span>
                  }
                </div> : <div onClick={()=>this.getRouterAndSetBreadcrumb(item)} className={this.state.chooseid === item.id?`flex item-link active`:'flex item-link'}>
                        <span className='left'>
                          {item.iconType === 'fa' ? <i className={`prefix-icon fa ${item.icon}`}></i> :
                              <Icon className='prefix-icon' type={item.icon}/>}
                        </span>
                  {
                      this.props.collapsed && <span className='flex right'>
                        <div>{item.name}</div>
                        {item.children && item.children.length &&
                            <i className='suffix-icon fa fa-angle-down'></i>}</span>
                  }
                </div>
          }
          {
              item.children && item.children.length && this.props.collapsed && <div
                  style={{height: this.state.currentOpenIds.includes(item.id) ? `auto` : '0px'}}
                  className={`left-nav-item-children`}>
                {
                  item.children.map((children_item, children_index) => {
                    return <div className='left-nav-item-children-item' key={children_item.id}>
                      {this.computedChild(children_item)}
                    </div>
                  })
                }
              </div>
          }
        </div>
    )
  }

  componentWillMount() {

  }

  componentDidMount() {
    const type = Number(getStorage('userList').clerklevel)
    if (type === 8) {
      const menu = [
        {
          "name": "首页",
          "rank": "2",
          "rule": "/home",
          "pid": "22",
          "id": "1",
        },
        {
          "name": "基本信息",
          "rank": "3",
          "rule": "/base",
          "id": "21",
        },
        {
          "name": "创新综述",
          "rank": "3",
          "rule": "/innovationReview",
          "id": "22",
        },
        {
          "name": "创新项一",
          "rank": "3",
          "rule": "/innovationItem1",
          "id": "23",
        },
        {
          "name": "创新项二",
          "rank": "3",
          "rule": "/innovationItem2",
          "id": "24",
        },
        {
          "name": "创新项三",
          "rank": "3",
          "rule": "/innovationItem3",
          "id": "25",
        },
        {
          "name": "创新项四",
          "rank": "3",
          "rule": "/innovationItem4",
          "id": "26",
        },
        {
          "name": "创新项五",
          "rank": "3",
          "rule": "/innovationItem5",
          "id": "27",
        },
        {
          "name": "创新项六",
          "rank": "3",
          "rule": "/innovationItem6",
          "id": "28",
        },
        {
          "name": "创新项七",
          "rank": "3",
          "rule": "/innovationItem7",
          "id": "29",
        },
        {
          "name": "个人信息",
          "rank": "2",
          "rule": "/personinfo",
          "id": "3",
        }
      ]
      this.setState({
        leftNavData:menu
      })
    } else if (type === 17 || type === 16) {
      const menu = [
        {
          "name": "首页",
          "rank": "2",
          "rule": "/homeCentral",
          "pid": "22",
          "id": "1",
        },
        {
          "name": "基本信息",
          "rank": "3",
          "rule": "/base",
          "id": "21",
        },
        {
          "name": "创新综述",
          "rank": "3",
          "rule": "/innovationReview",
          "id": "22",
        },
        {
          "name": "创新项一",
          "rank": "3",
          "rule": "/innovationItem1",
          "id": "23",
        },
        {
          "name": "创新项二",
          "rank": "3",
          "rule": "/innovationItem2",
          "id": "24",
        },
        {
          "name": "创新项三",
          "rank": "3",
          "rule": "/innovationItem3",
          "id": "25",
        },
        {
          "name": "创新项四",
          "rank": "3",
          "rule": "/innovationItem4",
          "id": "26",
        },
        {
          "name": "创新项五",
          "rank": "3",
          "rule": "/innovationItem5",
          "id": "27",
        },
        {
          "name": "创新项六",
          "rank": "3",
          "rule": "/innovationItem6",
          "id": "28",
        },
        {
          "name": "创新项七",
          "rank": "3",
          "rule": "/innovationItem7",
          "id": "29",
        },
        {
          "name": "个人信息",
          "rank": "2",
          "rule": "/personinfo",
          "id": "3",
        }
      ]
      this.setState({
        leftNavData:menu
      })
    } else if (type === 3 || type === 4) {
      const menu = [
        {
          "name": "首页",
          "rank": "2",
          "rule": "/homeScore",
          "pid": "22",
          "id": "1",
        },
        {
          "name": "博物馆推介展示",
          "rank": "2",
          "rule": "/meterial",
          "id": "2",
          'iconType':'fa',
          'children':[
            {
              "name": "基本信息",
              "rank": "3",
              "rule": "/base",
              "id": "21",
            },
            {
              "name": "创新综述",
              "rank": "3",
              "rule": "/innovationReview",
              "id": "22",
            },
            {
              "name": "创新项一",
              "rank": "3",
              "rule": "/innovationItem1",
              "id": "23",
            },
            {
              "name": "创新项二",
              "rank": "3",
              "rule": "/innovationItem2",
              "id": "24",
            },
            {
              "name": "创新项三",
              "rank": "3",
              "rule": "/innovationItem3",
              "id": "25",
            },
            {
              "name": "创新项四",
              "rank": "3",
              "rule": "/innovationItem4",
              "id": "26",
            },
            {
              "name": "创新项五",
              "rank": "3",
              "rule": "/innovationItem5",
              "id": "27",
            },
            {
              "name": "创新项六",
              "rank": "3",
              "rule": "/innovationItem6",
              "id": "28",
            },
            {
              "name": "创新项七",
              "rank": "3",
              "rule": "/innovationItem7",
              "id": "29",
            }
          ]
        },
        {
          "name": "流程管理",
          "rank": "2",
          "rule": "/progress",
          "id": "3",
        },
        {
          "name": "博物馆录入",
          "rank": "2",
          "rule": "/library",
          "id": "4",
        },
        {
          "name": "查询统计",
          "rank": "2",
          "rule": "/",
          "id": "5",
          'children':[
            {
              "name": "数据查询",
              "rank": "3",
              "rule": "/dataselect",
              "id": "51",
            },
            {
              "name": "投票人列表",
              "rank": "3",
              "rule": "/list",
              "id": "52",
            },
          ]
        },
        {
          "name": "专家管理",
          "rank": "2",
          "rule": "/specialist",
          "id": "6",
        },
        {
          "name": "用户管理",
          "rank": "2",
          "rule": "/dataselect",
          "id": "7",
          'children':[
            {
              "name": "博协用户",
              "rank": "2",
              "rule": "/user",
              "id": "71",
            },
            {
              "name": "博物馆用户",
              "rank": "2",
              "rule": "/libraryUser",
              "id": "72",
            },
          ]
        },
        {
          "name": "个人信息",
          "rank": "2",
          "rule": "/personinfo",
          "id": "8",
        }
      ]
      this.setState({
        leftNavData:menu
      })
    }
    this.listenRouterChange();
    this.initOpenAll();
    this.initCurrentActive();
  }


  componentDidUpdate(item) {

  }


  render() {
    return (
      <div ref='leftNav' className={`left-nav ${this.props.collapsed ? 'left-nav-open' : 'left-nav-close'}`}>
        <CScroll>
          {
            this.state.leftNavData.map((item, index) => {
              return <div key={item.id}>
                {
                  this.props.collapsed ? <div>
                    {this.computedChild(item)}
                  </div>: <div>
                    {item.children && item.children.length ? <Popover content={this.popoverContentRender(item)} placement='right' overlayClassName='popover-content-render' getPopupContainer={()=>this.refs.leftNav}>
                      {this.childrenRender(item)}
                    </Popover> : this.childrenRender(item)}
                  </div>
                }
              </div>
            })
          }
        </CScroll>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    collapsed: state.collapsed,
    libraryname:state.libraryname
  }
};

export default compose(withRouter, connect(mapStateToProps))(LeftNav);
